import { useBunja } from 'bunja/react';
import { useAtomValue } from 'jotai';

import { Tooltip } from '@flipster/react/design-system-legacy/tooltip';
import { IconButton } from '@flipster/react/design-system/icon-button';
import Formatted from '@flipster/react/design-utils/formatted';
import InformationCircleIcon from '@flipster/react/icon/generated/InformationCircleIcon';
import { walletsBunja } from '@flipster/socket/r230522/wallet';
import { css } from '@flipster/styled-system/css';
import { hstack } from '@flipster/styled-system/patterns';
import { alert } from '@flipster/ui/Alert';
import { PusdtCurrency, UsdCurrencyList, UsdPrecision, UsdtCurrency } from '@flipster/utils/constants/currency';

export const TotalBalance = ({ currency }: { currency: string }) => {
  const { walletsAtom } = useBunja(walletsBunja);
  const wallets = useAtomValue(walletsAtom);
  const balance = wallets?.[currency]?.walletBalanceExclWithdrawalPending ?? 0;
  const precision = UsdCurrencyList.includes(currency) ? UsdPrecision : 8;
  const displayCurrency = currency === PusdtCurrency ? UsdtCurrency : currency;

  const tooltipContents = (
    <ul className={css({ list: 'disc' })}>
      <li>Displays the total balance of selected asset.</li>
      <li>Unrealized P&L is not included in the Total Balance.</li>
    </ul>
  );

  return (
    <div
      className={hstack({
        h: 48,
        justify: 'space-between',
      })}
    >
      <div className={hstack()}>
        <span className={css({ textStyle: 'Text/M/Regular', color: 'content.default.level-4' })}>Total balance</span>
        <Tooltip
          placement='bottom'
          crossAxisOffset={75}
          maxWidth={500}
          mobileAlert={() => alert.show({ title: 'Total balance', message: tooltipContents, confirmText: 'OK' })}
        >
          <Tooltip.Trigger asChild>
            <IconButton icon={<InformationCircleIcon />} size='small' hierarchy='quaternary' />
          </Tooltip.Trigger>
          <Tooltip.Content>{tooltipContents}</Tooltip.Content>
        </Tooltip>
      </div>
      <Formatted.Number
        value={balance}
        toFixed
        precision={precision}
        suffix={displayCurrency}
        css={{ textStyle: 'Text/M/Monospace/Strong', color: 'content.default.level-4' }}
      />
    </div>
  );
};
